import { handleActions } from "redux-actions";
import * as addCustomerActions from "../actions/customers";

const initState = {
  customer: null,
  loading: false,
  errorMessage: null
};

export const customerCard = handleActions(
  {
    [addCustomerActions.editCustomer]: (state, _action) => {
      return {
        ...state,
        isEdit: false
      };
    },
    [addCustomerActions.editCustomerSuccess]: (state, action) => {
      return {
        ...state,
        customer: action.payload,
        updated: state.updated ? state.updated + 1 : 1,
        isEdit: true
      };
    },
    [addCustomerActions.editCustomerError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        isEdit: false,
        errors: payload.data,
        errorMessage: payload.message
      };
    },
    [addCustomerActions.getCustomer]: (state, _action) => {
      return { ...state, loading: true };
    },
    [addCustomerActions.getCustomerSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        customer: payload,
        loading: false
      };
    },
    [addCustomerActions.getCustomerError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false
      };
    }
  },
  initState
);
